// src/components/SplashScreen.js

import React, { useMemo, useRef, useEffect } from 'react';
import { OnboardingLayout } from './OnboardingLayout';
import { getRandomMessage } from '../utils/getSplashMessage';
import './SplashScreen.css'; // optional for styling

export function SplashScreen({ theme, message, splashLines, setupLog, ui_state }) {

  const logRef = useRef(null);

  useEffect(() => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  }, [setupLog]);

  // Select a random message once per mount
  const splashMessage = useMemo(() => getRandomMessage(theme), [theme]); // [theme] is dependency - only rerun function if theme changes, stabalizes message when connecting-message cycles

  const isSplashVisible = !(setupLog?.length > 0);

  useEffect(() => {
    if (isSplashVisible && splashMessage?.id) {
      // Persist locally
      localStorage.setItem("splash_message_id", splashMessage.id);

      // Send to backend securely
      fetch(`${process.env.REACT_APP_API_URL}/api/session/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("authToken")}`
        },
        body: JSON.stringify({
          session_id: localStorage.getItem("session_id"),
          splash_message_id: splashMessage.id
        })
      });
    }
  }, [isSplashVisible, splashMessage]);



  useEffect(() => {
    if (!splashMessage?.id) return;

    const sessionId = localStorage.getItem("session_id");
    const token = localStorage.getItem("authToken");

    if (!sessionId || !token) return;

    fetch(`${process.env.REACT_APP_API_URL}/api/session/message_exposure`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        session_id: sessionId,
        message_id: splashMessage.id,
        theme,
        ui_state
      })
    });
  }, [splashMessage]);


  
  return (
    <OnboardingLayout 
      splashMessage={splashMessage.text} 
      splashMessageId={splashMessage.id}
      splashLines={splashLines}
    >
      {/* If setupLog exists, render persistent timestamped log */}
      {setupLog?.length > 0 ? (
        <div className="setup-log" ref={logRef}>
          {setupLog.map((entry, i) => (
            <div key={i} className="setup-log-entry" style={{ '--index': i }}>
              <span className="timestamp">{new Date(entry.timestamp).toLocaleTimeString()}</span>
              <span className="message">{entry.message}</span>
            </div>
          ))}
          <div className="cursor" />  
        </div>
      ) : (
        // Fallback to transient message
        <h2 className="connecting-message">{message}</h2>
      )}
    </OnboardingLayout>
  );
}